import {CompleteBooking} from './Booking';
import {FullUserDTO, UserDTO} from './User';

export type PadelResult = {
  id: string;
  bookingId: string;
  player1Team1Id: string;
  player1Team1?: UserDTO;
  player2Team1Id: string;
  player2Team1?: UserDTO;
  player1Team2Id: string;
  player1Team2?: UserDTO;
  player2Team2Id: string;
  player2Team2?: UserDTO;
  matchType?: MatchType;
  score: PadelScore[];
  winnerTeam: WinnerTeam;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  review: FullReview[];
};

export type CompletePadelResult = {
  id: string;
  bookingId: string;
  player1Team1Id: string;
  player2Team1Id: string;
  player1Team2Id: string;
  player2Team2Id: string;
  score: PadelScore[];
  matchType?: MatchType;
  winnerTeam: WinnerTeam;
  player1Team1?: UserDTO;
  player2Team1?: UserDTO;
  player1Team2?: UserDTO;
  player2Team2?: UserDTO;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  review: FullReview[];
};

export type TennisResult = {
  id: string;
  bookingId: string;
  matchType?: MatchType;
  player1Team1Id: string;
  player1Team1?: UserDTO;
  player2Team1Id: string;
  player2Team1?: UserDTO;
  player1Team2Id: string;
  player1Team2?: UserDTO;
  player2Team2Id: string;
  player2Team2?: UserDTO;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  score: PadelScore[];
  winnerTeam: WinnerTeam;
  review: Array<FullReview>;
};

export type CompleteTennisResult = {
  id: string;
  bookingId: string;
  matchType?: MatchType;
  player1Team1Id?: string;
  player2Team1Id?: string;
  player1Team2Id: string;
  player2Team2Id?: string;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  score: PadelScore[];
  winnerTeam: WinnerTeam;
  player1Team1?: UserDTO;
  player2Team1?: UserDTO;
  player1Team2?: UserDTO;
  player2Team2?: UserDTO;
  review: FullReview[];
};

export type PickleballResult = {
  id: string;
  bookingId: string;
  matchType?: MatchType;
  player1Team1Id: string;
  player1Team1?: UserDTO;
  player2Team1Id: string;
  player2Team1?: UserDTO;
  player1Team2Id: string;
  player1Team2?: UserDTO;
  player2Team2Id: string;
  player2Team2?: UserDTO;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  score: PadelScore[];
  winnerTeam: WinnerTeam;
  review: FullReview[];
};

export type CompletePickleballResult = {
  id: string;
  bookingId: string;
  matchType?: MatchType;
  player1Team1Id: string;
  player2Team1Id?: string;
  player1Team2Id: string;
  player2Team2Id?: string;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  score: PadelScore[];
  winnerTeam: WinnerTeam;
  player1Team1?: UserDTO;
  player2Team1?: UserDTO;
  player1Team2?: UserDTO;
  player2Team2?: UserDTO;
  review: FullReview[];
};

export type CreateMatchResultDTO = {
  sportId: number;
  bookingId: string;
  matchType?: MatchType;
  player1Team1Id?: string;
  player2Team1Id?: string;
  player1Team2Id?: string;
  player2Team2Id?: string;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  score?: PadelScore[];
  winnerTeam?: WinnerTeam;
};

export type UpdateMatchDTO = {
  player1Team1Id?: string;
  player2Team1Id?: string;
  player1Team2Id?: string;
  player2Team2Id?: string;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  score?: PadelScore[];
  winnerTeam?: WinnerTeam;
};

export type PadelScore = {
  team1: number;
  team2: number;
};

export enum WinnerTeam {
  Team1 = 'team1',
  Team2 = 'team2',
}

export enum MatchType {
  Single = 'Single',
  Double = 'Double',
}

export type MatchByUserIdDTO = {
  id: string;
  bookingId: string;
  booking: CompleteBooking;
  matchType: MatchType;
  player1Team1Id: string;
  player2Team1Id?: string;
  player1Team2Id: string;
  player2Team2Id?: string;
  player1Team1Score?: number;
  player2Team1Score?: number;
  player1Team2Score?: number;
  player2Team2Score?: number;
  score: PadelScore[];
  winnerTeam: WinnerTeam;
  player1Team1?: UserDTO;
  player2Team1?: UserDTO;
  player1Team2?: UserDTO;
  player2Team2?: UserDTO;
};

export type FullReview = {
  id: string;
  matchId: string;
  reviewerId: string;
  reviewer: FullUserDTO;
  playerId: string;
  player: FullUserDTO;
  rating?: number;
};

export type UpdateReviewDTO = {
  reviewerId: string;
  playerId: string;
  rating?: number;
};
